import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'
import {
	type HttpAddPhotosetSpaceCommentOptions,
	httpAddPhotosetSpaceComment
} from '../http/photoset.http'
import type { PhotosetSpace } from '../types'

export const useAddPhotosetSpaceComment = (
	urlParams: HttpAddPhotosetSpaceCommentOptions['urlParams'],
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpAddPhotosetSpaceCommentOptions['payload']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpAddPhotosetSpaceComment({ urlParams, payload }),
		onError: (error) => errorHandler(error),
		onSuccess: (data, variables, onMutateResult, context) => {
			// Update cached data
			queryClient.setQueriesData(
				{ queryKey: [QUERY_KEYS.PHOTOSET_SPACES] },
				(currentPhotosetSpaces: PhotosetSpace[] | undefined) => {
					if (!currentPhotosetSpaces) {
						return currentPhotosetSpaces
					}

					return (
						currentPhotosetSpaces.map((photosetSpace) => ({
							...(photosetSpace.id === urlParams.photosetSpaceId
								? {
										...photosetSpace,
										comment: variables.comment
									}
								: photosetSpace)
						})) ?? []
					)
				}
			)

			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
